import { Map } from 'immutable';

import * as t from '../actions/personalizedStudyActionTypes';

const initialState = Map({
  availableChapters: undefined,
  availableChaptersLoading: false,
  saveChaptersLoading: false,
  chapterStudyPlan: undefined,
  buildChapterStudyPlanLoading: false,
});

const reducer = function personalizedStudyReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.SET_AVAILABLE_CHAPTERS:
      return state.set('availableChapters', action.chapters);

    case t.SET_AVAILABLE_CHAPTERS_LOADING:
      return state.set('availableChaptersLoading', action.loading);

    case t.SET_SAVE_CHAPTERS_LOADING:
      return state.set('saveChaptersLoading', action.loading);

    case t.SET_CHAPTER_STUDY_PLAN:
      return state.set('chapterStudyPlan', action.plan);

    case t.SET_BUILD_CHAPTER_STUDY_PLAN_LOADING:
      return state.set('buildChapterStudyPlanLoading', action.loading);

    default:
      return state;
  }
};

export default reducer;
